import { FullStory as FS, init } from "@fullstory/browser";

let initialized = false;

export function initializeFullStory(orgId: string | undefined) {
    if (initialized) return;
    if (!orgId) return;
    
    init({
        orgId,
        debug: false,
        namespace: 'FS'
    });

    initialized = true;
}

export function enableFullStory(fingerprint: string) {
    if (!initialized) return;
    FS('setIdentity', { uid: fingerprint });
    FS('restart');
}

export function disableFullStory() {
    if (!initialized) return;
    FS('shutdown');
}